<template>
  <el-dialog id="bb" :center="true" :close-on-click-modal="false" title="学生基本信息" :visible.sync="showEdit"
    @close="closeEditDialog">
    <el-form ref="order" :model="order" label-width="100px">
      <el-form-item label="学生姓名" style="width: 100%;">
        <el-input clearable v-model="order.studentName" placeholder="请输入学生姓名" style="width: 100%"></el-input>
      </el-form-item>
      <el-form-item label="年级" style="width: 100%;">
        <el-cascader clearable style="width: 100%;" v-model="order.grade" :options="order.gradeList"
          :props="props"></el-cascader>
      </el-form-item>
      <el-form-item label="性别">
        <el-radio-group v-model="order.sex">
          <el-radio label="1">男</el-radio>
          <el-radio label="2">女</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="学生状态">
            <el-select class="select" filterable  clearable v-model="order.state" placeholder="请选择" style="width:100%;">
              <el-option v-for="item in classTypes_s" :key="item.value" :value="item.value" :label="item.label">
              </el-option>
            </el-select>
      </el-form-item>

        <el-form-item label="所在地域:">
            <el-select v-model="order.regionName" clearable filterable placeholder="请选择所在地域" style="width:100%;">
              <el-option v-for="item in optionsListt" :key="item.id" :label="item.dictValue"
              :value="item.dictType"></el-option>
            </el-select>
        </el-form-item>

      <el-form-item label="家庭住址" style="width: 100%;">
        <el-input v-model="order.address" clearable placeholder="请输入家庭住址" style="width: 100%"></el-input>
      </el-form-item>
      <el-form-item label="家长电话" style="width: 100%;">
        <el-input clearable v-model="order.parentPhoneNumber" @input="phoneChange" placeholder="请输入家长电话"
          style="width: 100%"></el-input>
      </el-form-item>
      <el-form-item label="课程类别">
        <el-cascader clearable style="width: 100%;" v-model="order.courseCategoryIds" :options="categoryList"
          :props="propsCategory"></el-cascader>
      </el-form-item>
      <el-form-item label="学生类型">
        <el-select v-model="order.classType" style="width:100%;" placeholder="请选择学生类型" filterable  >
          <el-option v-for="item in classTypsArr" :key="item.value" :label="item.label" :value="item.value"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="线上诊断教师">
        <!-- <el-select clearable  multiple   v-model="order.teacherIdOnlineArr" placeholder="请选择诊断教师">
          <el-option v-for="item in teachers" :key="item.id" :label="item.realname" :value="item.id"></el-option>
        </el-select> -->
        <el-select multiple filterable   v-model="order.teacherIdOnlineArr" clearable style="width: 100%;" placeholder="请选择诊断老师">
          <el-option v-for="item in teachers" :key="item.id" :label="item.realname" :value="item.id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="线上诊断时间" id="time">
        <!-- <el-date-picker style="width: 100%;" v-model="order.startTime" placeholder="请选择授课时间" type="datetimerange"
                       value-format="yyyy-MM-dd HH:mm:ss"
                       format="yyyy-MM-dd HH:mm:ss"></el-date-picker> -->
        <el-date-picker v-model="order.onTime" type="date" style="width: 30%;" value-format="yyyy-MM-dd"
          placeholder="请选择诊断日期" clearable>
        </el-date-picker>
        <!-- <span class="el-icon-timer" @click="dianji"></span> -->
        <!-- <clock :time="time" v-show="isshow"></clock> -->

        <!-- <el-time-picker
          is-range
          v-model="order.startTimeHour"
          value-format="HH:mm:ss"
          range-separator="至"
          start-placeholder="开始时间"
          end-placeholder="结束时间"
          placeholder="选择时间范围"
        >
        </el-time-picker> -->
        <mz-time-select style="width: 30%; display:inline-block" :childPlaceholder="'开始时间'" :timePeriod="'start1'"
          @startTimeSelect="startTimeSelect" v-model="order.startTimeHour"
          :valueTime="order.startTimeHour"></mz-time-select>
        <span style="margin-left:5px"></span>

        <mz-time-select @clean="clean" style="width: 30%;display:inline-block" :childPlaceholder="'结束时间'"
          :timePeriod="'end1'" @startTimeSelect="startTimeSelect" v-model="order.onEndTime"
          :valueTime="order.onEndTime"></mz-time-select>
        <!-- <el-time-select
          style="width: 33%;"
          placeholder="起始时间"
          v-model="order.startTimeHour"
          :picker-options="{
            start: '06:00',
            step: '00:15',
            end: '24:00'
          }"
        >
        </el-time-select>
        <el-time-select
          v-model="order.onEndTime"
          style="width: 33%;"
          placeholder="结束时间"
          :picker-options="{
            start: '06:00',
            step: '00:15',
            end: '24:00'
          }"
        >
        </el-time-select> -->

        <el-checkbox v-model="checked">是否线上预约</el-checkbox>
      </el-form-item>

      <el-form-item label="线下诊断教师">
        <!-- <el-select   clearable style="width: 100%;" v-model="order.teacherIdOffline" placeholder="请选择诊断教师">
          <el-option v-for="item in teachers" :key="item.id" :label="item.realname" :value="item.id"></el-option>
        </el-select> -->

        <el-select multiple v-model="order.teacherIdOfflineArr" filterable   clearable style="width: 100%;" placeholder="请选择诊断老师">
          <el-option v-for="item in teachers" :key="item.id" :label="item.realname" :value="item.id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="线下诊断时间" id="time" style="margin-bottom: 0;">
        <el-date-picker style="width: 30%;" v-model="order.offTime" type="date" value-format="yyyy-MM-dd"
          placeholder="请选择诊断日期" clearable>
        </el-date-picker>
        <!-- <span class="el-icon-timer" @click="dianji1"></span> -->
        <!-- <clock :time="time" v-show="isshow1"></clock> -->
        <!-- <el-time-picker
          is-range
          v-model="order.OffTimeHour"
          value-format="HH:mm:ss"
          range-separator="至"
          start-placeholder="开始时间"
          end-placeholder="结束时间"
          placeholder="选择时间范围"
        >
        </el-time-picker> -->
        <mz-time-select @clean="clean" style="width: 30%; display:inline-block" :childPlaceholder="'开始时间'"
          :timePeriod="'start'" @startTimeSelect="startTimeSelect" v-model="order.OffTimeHour"
          :valueTime="order.OffTimeHour"></mz-time-select>
        <span style="margin-left:5px"></span>
        <mz-time-select @clean="clean" style="width: 30%;display:inline-block" :childPlaceholder="'结束时间'"
          :timePeriod="'end'" @startTimeSelect="startTimeSelect" v-model="order.offEndTime"
          :valueTime="order.offEndTime"></mz-time-select>
        <!-- <el-time-select
          style="width: 33%;"
          placeholder="起始时间"
          v-model="order.OffTimeHour"
          :picker-options="{
            start: '06:00',
            step: '00:15',
            end: '24:00'
          }"
        >
        </el-time-select>
        <el-time-select
          v-model="order.offEndTime"
          style="width:33%;"
          placeholder="结束时间"
          :picker-options="{
            start: '06:00',
            step: '00:15',
            end: '24:00'
          }"
        >
        </el-time-select> -->

        <el-checkbox v-model="checked1">是否线下预约</el-checkbox>
      </el-form-item>
      <el-form-item label="备注" style="margin-top: 20px;">
        <el-input :rows="2" type="textarea" placeholder="请输入诊断备注" v-model="order.remarks">
        </el-input>
      </el-form-item>

      <el-divider content-position="center">付款信息</el-divider>
      <el-form-item label="订单状态">
        <el-select v-model="order.orderStatus" filterable   placeholder="请选择" style="width: 100%;">
          <el-option v-for="item in orderType" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>






      <!-- <el-form-item v-if="order.isRenew == 1" v-for="(item, index) in order.renews" :key="index" style="margin-left: 50px;">
        <el-form-item style="margin-left: -122px" label="续费金额：">
          <el-input v-model="item.renewMoney" autocomplete="off" size="small" type="text"
            placeholder="请输入续费金额"></el-input>
        </el-form-item>
        <el-form-item style="margin-left: -122px" label="续费时间：">
          <el-date-picker v-model="item.renewTime" value-format="yyyy-MM-dd" type="date" style="width: 100%" size="small"
            placeholder="选择续费日期">
          </el-date-picker>
        </el-form-item>
        <el-form-item style="margin-left: -122px" label="续费渠道：">
          <el-select v-model="item.renewType" size="small" style="margin-top: 5px;width: 100%" placeholder="请选择续费渠道">
            <el-option v-for="item in payTypes" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
      </el-form-item>  -->




      <el-form-item style="margin-top: -10px" label="是否交定金：" label-width="150px">
        <el-radio-group v-model="order.isDiagnosisAllPay">
          <el-radio label="1">是</el-radio>
          <el-radio label="2">否</el-radio>
        </el-radio-group>
        <el-form-item style="margin-left: -122px" v-if="order.isDiagnosisAllPay == 1" label="付款金额：">
          <el-input clearable v-model="order.diagnosisAllPayMoney" autocomplete="off" size="small" placeholder="请输入付款金额"></el-input>
        </el-form-item>
        <el-form-item style="margin-left: -122px" v-if="order.isDiagnosisAllPay == 1" label="付款时间：">
          <el-date-picker v-model="order.diagnosisTime" value-format="yyyy-MM-dd" type="date" style="width: 100%"
            size="small" clearable placeholder="选择付款日期">
          </el-date-picker>
        </el-form-item>
        <el-form-item style="margin-left: -122px" v-if="order.isDiagnosisAllPay == 1" label="付款渠道：">
          <el-select  filterable   v-model="order.payType" size="small" style="margin-top: 5px;width: 100%" placeholder="请选择付款渠道">
            <el-option v-for="item in payTypes" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
      </el-form-item>
      <el-form-item label="尾款付费情况：" label-width="150px">

        <el-radio-group v-model="order.isAllPay" >
          <el-radio  :label="1" @click.native.prevent="clickitem(1)">全额尾款</el-radio>
          <el-radio  :label="2" @click.native.prevent="clickitem(2)">分期尾款</el-radio>
        </el-radio-group>

        <!-- <el-radio-group v-model="order.isAllPay">
          <el-radio :label="1" @change="isFull" @click.native.prevent="clickitem(1)">全额尾款</el-radio>
          <el-radio :label="2" @change="isNo" @click.native.prevent="clickitem(2)">分期尾款</el-radio>
        </el-radio-group> -->
        <!--        <el-radio v-model="order.isAllPay" label="3" @change="isNo"-->
        <!--        >取消尾款-->
        <!--        </el-radio-->
        <!--        >-->
        <el-form-item style="margin-left: -122px" v-if="order.isAllPay == 1" label="付款金额：">
          <el-input v-model="order.allPayMoney" autocomplete="off" size="small" type="text"
            placeholder="请输入付款金额"></el-input>
        </el-form-item>
        <el-form-item style="margin-left: -122px" v-if="order.isAllPay == 1" label="付款时间：">
          <el-date-picker v-model="order.payTime" value-format="yyyy-MM-dd" type="date" style="width: 100%" size="small"
            placeholder="选择付款日期">
          </el-date-picker>
        </el-form-item>
        <el-form-item style="margin-left: -122px" v-if="order.isAllPay == 1" label="付款渠道：">
          <el-select v-model="order.payAlltype" size="small" style="margin-top: 5px;width: 100%" placeholder="请选择付款渠道">
            <el-option v-for="item in payTypes" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item style="margin-left: -122px" v-if="order.isAllPay == 1" label="学业课：">
          <el-input v-model="order.classHour" autocomplete="off" size="small" type="text"  placeholder="请输入学业课"></el-input>
        </el-form-item>
        <el-form-item style="margin-left: -122px" v-if="order.isAllPay == 1" label="家庭教育课：">
          <el-input v-model="order.familyHour" autocomplete="off" size="small" type="text"  placeholder="请输入家庭教育课"></el-input>
        </el-form-item>


        <el-form-item style="margin-left:-99px;" v-if="order.isAllPay == 2">
          <el-button icon="el-icon-circle-plus-outline" @click="addInput"></el-button>
          <el-button icon="el-icon-remove-outline" @click="removeItem"></el-button>
        </el-form-item>
      </el-form-item>
      <el-form-item style="margin-left: -99px;" v-if="order.isAllPay == 2">
        <el-form-item v-for="(item, index) in order.stages" :key="index" :label="'第' + (index + 1) + '期'">
          <el-input v-model="item.stagesMoney" size="small" style="width: 80%;" placeholder="请输入付款金额"></el-input>
          <el-date-picker v-model="item.stagesDate" type="date" value-format="yyyy-MM-dd" size="small" style="width: 80%;"
            placeholder="选择付款日期">
          </el-date-picker>
          <el-select v-model="item.payType" size="small" style="width: 80%;" placeholder="请选择付款渠道">
            <el-option v-for="item in payTypes" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
          <el-input v-model="item.agingClassHour" autocomplete="off" size="small" type="text" style="width: 80%;"  placeholder="请输入分期尾款学业课时数"></el-input>
          <el-input v-model="item.agingFamilyHour" autocomplete="off" size="small" type="text" style="width: 80%;"  placeholder="请输入分期尾款家庭教育课时数"></el-input>
        </el-form-item>
      </el-form-item>
      <el-form-item style="margin-top: -10px" label="是否续费：" label-width="150px">
        <el-radio-group v-model="order.isRenew" @change="qq">
          <el-radio label=1>是</el-radio>
          <el-radio label=2>否</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item style="margin-left:-99px;" v-if="order.isRenew == 1">
        <el-button icon="el-icon-circle-plus-outline" @click="addInput1"></el-button>
        <el-button icon="el-icon-remove-outline" @click="removeItem1"></el-button>
      </el-form-item>

      <el-form-item style="margin-left: -99px;" v-if="order.isRenew == 1">
        <el-form-item v-for="(item, index) in order.renews" :key="index" :label="'第' + (index + 1) + '期'">
          <el-input v-model="item.renewMoney" size="small" style="width: 80%;" placeholder="请输入续费金额"></el-input>
          <el-date-picker v-model="item.renewTime" type="date" value-format="yyyy-MM-dd" size="small" style="width: 80%;"
            placeholder="选择续费日期">
          </el-date-picker>
          <el-select v-model="item.renewType" size="small" style="width: 80%;" placeholder="请选择续费渠道">
            <el-option v-for="item in payTypes" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
          <el-input v-model="item.classHourRenew" autocomplete="off" size="small" type="text" style="width: 80%;"  placeholder="请输入学业课时数"></el-input>
          <el-input v-model="item.familyHourRenew" autocomplete="off" size="small" type="text" style="width: 80%;"  placeholder="请输入家庭教育课时数"></el-input>
        </el-form-item>
      </el-form-item>

        <el-form-item style="" label="审批人">
          <el-select v-model="ApprovalPeople" size="small" style="width: 100%;" placeholder="请选择审批人">
              <el-option v-for="item in optionList2"  :key="item.id"  :value="item.id" :label="item.realname"></el-option>
            </el-select>
        </el-form-item>
        <el-form-item label="备注">
            <el-input v-model="chengRemarks" :autosize="{ minRows: 6, maxRows: 6 }" type="textarea"  placeholder="请输入备注" maxlength="300" show-word-limit></el-input>
        </el-form-item>


    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button size="small" @click="closeEditDialog">取消</el-button>
      <el-button size="small" type="primary" @click="saveEditForm">保存</el-button>
    </span>
  </el-dialog>
</template>

<script>
// import Clock from "vue-clock2";
import axios from "axios";
import apiBaseUrl from "../../../config/api";

export default {
  // components: { Clock },
  data () {
    return {

      chengRemarks:'',
      ApprovalPeople: 63,
      optionList2:[],

      classTypes_s: [{ value: 1, label: '在读' }, { value: 2, label: '结业' }, { value: 3, label: '停课' },{ value: 4, label: '流失' }],
      checked: false,
      checked1: false,
      expireTimeOption: {
        disabledDate (date) {
          //disabledDate 文档上：设置禁用状态，参数为当前日期，要求返回 Boolean
          return date.getTime() < Date.now() - 24 * 60 * 60 * 1000;
        }
      },
      // time: '6:00',//钟表时间
      teachers: [], //老师集合
      categoryList: [], //课程集合
      orderType: [
        {
          value: 1,
          label: '已成单'
        }, {
          value: 2,
          label: '已关单'
        },
        {
          value: 3,
          label: '已退费'
        },
      ],
      props: {
        label: "gradeName",
        children: "children",
        value: "id"
      },
      propsCategory: {
        label: "categoryName",
        children: "children",
        value: "id"
      },
      payTypes: [
        {
          value: 1,
          label: "现金"
        },
        {
          value: 2,
          label: "微信"
        },
        {
          value: 3,
          label: "支付宝"
        },
        {
          value: 4,
          label: "银行卡"
        },
        {
          value: 5,
          label: "公户"
        },
        {
          value: 6,
          label: "小鹅通"
        },
        {
          value: 7,
          label: "美团"
        },
        {
          value: 8,
          label: "公户（桑穆）"
        },
        {
          value: 9,
          label: "公户（博川）"
        },
        {
          value: 10,
          label: "公户（蒙正心理）"
        },
      ], // 付款渠道选项
      customer: {},

      optionsListt:[
        {dictValue:"北京", dictType:1 },
        {dictValue:"深圳", dictType:2 },
      ],

      // customerId: 0,
      order: {
        classHour: "",
        familyHour: "",
        state:"",
        classType: '',
        isRenew: "2",//是否续费
        orderStatus: "",//成单状态
        remarks: "", //备注
        parentPhoneNumber: "", //家长电话
        offTeacher: "",
        OffTimeHour: "", //线下诊断时间小时
        startTimeDay: "", //诊断时间天数
        startTimeHour: "", //诊断时间小时段
        payAlltype: "",
        gradeList: [], //年级
        teacherId: "", //诊断老师id
        startTime: [], //授课时间
        payType: "", //全款付款方式
        type: "", //成交状态
        onTime: "",
        offTime: "",
        onEndTime: "", //线上结束时间
        offEndTime: "", //线下结束时间
        onlineStatus: "", //如果线上checked为true他就不为空
        offlineStatus: "", //如果线下checked为true他就不为空
        onlineTime: [], //线上诊断时间
        teacherIdOffline: "", //线下诊断教师
        teacherIdOfflineArr: [],
        teacherIdOnline: "", //线上诊断教师
        teacherIdOnlineArr: [],
        offlineTime: [], //线下诊断时间
        isDiagnosisAllPay: "", //是否交诊断费
        Lastselected: '',//取消
        diagnosisAllPayMoney: "", //诊断费用
        diagnosisTime: "", //诊断费用付款时间
        diagnosisPayType: "", //诊断费用付款方式
        allPayMoney: "", //全款费用
        payTime: "", //交全款时间
        isAllPay: "", //是否是全额尾款，分期尾款
        studentName: "", //学生姓名
        grade: [], //年级id
        sex: "", // 性别
        address: "", //家庭地址
        regionName:'',
        studentId: "", //学生ID
        courseCategoryIds: [], //课程id
        customerInformationId: "", //客资id
        renews: [
          {
            renewType: "",//续费方式
            renewTime: "",//续费时间
            renewMoney: "",//续费金额
            classHourRenew: "",
            familyHourRenew: "",
          }
        ],
        stages: [
          {
            stagesMoney: "", // 分期金额
            stagesDate: "", // 分期时间
            payType: "", // 付款渠道
            agingClassHour: "",
            agingFamilyHour: ""
          }
        ]
      },
      classTypsArr: [{ value: 1, label: '规划' }, { value: 2, label: '线下' }, { value: 3, label: '纯补课' }],
      showEdit: false,
      rules: {
        studentName: [
          {
            required: true,
            message: "请输入学生名称",
            trigger: "blur"
          }
        ],
        grade: [
          {
            required: true,
            message: "请选择年级",
            trigger: "change"
          }
        ],
        sex: [{ required: true, message: "请选择性别", trigger: "change" }],
        address: [
          {
            required: true,
            message: "请输入家庭住址",
            trigger: "blur"
          }
        ],
        parentPhoneNumber: [
          {
            required: true,
            message: "请输入家长电话",
            trigger: "blur"
          },
          { type: "number", message: "家长电话必须为数字值" }
        ],
        courseCategoryIds: [
          { required: true, message: "请选择课程类别", trigger: "change" }
        ],
        teacherId: [
          { required: true, message: "请选择授课教师", trigger: "change" }
        ],
        startTime: [
          { required: true, message: "请选择授课时间", trigger: "change" }
        ]
      }
    };
  },
  computed: {},
  watch: {},
  methods: {
    phoneChange() {
      this.order.parentPhoneNumber = this.order.parentPhoneNumber.replace(/[^\d]/g, "");
      if (this.order.parentPhoneNumber.length > 11) {
        this.order.parentPhoneNumber = this.order.parentPhoneNumber.substr(0, 11);
      }
      let reg = /^1[3456789]\d{9}$/;
      if (this.order.parentPhoneNumber.length >= 11 && !reg.test(this.order.parentPhoneNumber)) {
         this.$notify({
          title: '警告',
          message: '请输入正确的手机号码格式',
          type: 'warning'
        });
      }
    },
    qq () {
      console.log(this.order.isRenew);
    },
    startTimeSelect (val, row) {
      if (val == "start") {
        this.order.OffTimeHour = row
      } else if (val == "end") {
        this.order.offEndTime = row
      } else if (val == "start1") {
        this.order.startTimeHour = row
      } else {
        this.order.onEndTime = row
      }

      console.log(val);
    },
    endTimeSelect (val) {
      this.order.offEndTime = val
      console.log(val);
    },
    handleinput(e){
      console.log(e)
    },
    clickitem (val) {

      if(this.order.isAllPay === val ){
         this.order.isAllPay = ''
      }else{
         this.order.isAllPay = val
      }

      if(val === 1){
          this.order.allPayMoney = ""
          this.order.payTime = ""
          this.order.payAlltype = ""
          this.order.classHour = ""
          this.order.familyHour = ""
      }
      if(val === 2){
        this.order.stages = [
          {
            stagesMoney: "", // 分期金额
            stagesDate: "", // 分期时间
            payType: "", // 付款渠道
            agingClassHour: "",
            agingFamilyHour: ""
          }
        ]
      }
    },
    clean (val) {
      if (val == "start") {
        this.diagnosisOff.startTimeHour = ''
      } else {
        this.diagnosisOff.endTimeHour = ''
      }
    },
    clearDiagnosis () {
      if (
        this.order.isDiagnosisAllPay == "2" ||
        this.order.isDiagnosisAllPay == "3"
      ) {
        this.order.diagnosisAllPayMoney = "";
        this.order.diagnosisTime = "";
        this.order.diagnosisPayType = "";
      }
    },
    //点击显示钟表
    // dianji() {
    //   this.isshow = !this.isshow;
    // },
    // dianji1() {
    //   this.isshow1 = !this.isshow1;
    // },
    //绑定课程id
    handleChange (val) {
      if (val === this.Lastselected) {
        // 取消选择
        this.isDiagnosisAllPay = '';
      }
      this.Lastselected = this.isDiagnosisAllPay;
    },
    // bingCategory() {
    //   if (this.order.diagnosisAllPayMoney == 2000) {
    //     this.order.courseCategoryId = [25, 26];
    //   }
    // },
    init (customerId) {
      // this.customerId = customerId;
      this.showEdit = true;
      axios
        .get(`${apiBaseUrl}/customerinformation/getOne/${customerId}`,{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        })
        .then(res => {
          if (res.data.code === 200) {
            this.order.studentId = res.data.data.list.studentId;
            this.order.isRenew = res.data.data.list.isRenew + ''
            if (res.data.data.list.renew != null) {
              this.order.renews = JSON.parse(res.data.data.list.renew)
            }


            this.order.state = res.data.data.list.state

            this.order.classHour = res.data.data.list.classHour ? res.data.data.list.classHour : ""
            this.order.familyHour = res.data.data.list.familyHour ? res.data.data.list.familyHour : ""



            this.order.classType = res.data.data.list.classType
            this.order.remarks = res.data.data.list.remarks;
            this.order.parentPhoneNumber = res.data.data.list.parentPhoneNumber;
            this.order.customerInformationId = res.data.data.list.customerId;
            this.order.studentName = res.data.data.list.customerStudent;
            this.order.payType = res.data.data.list.payType;
            this.order.sex = res.data.data.list.sex;
            this.order.grade = res.data.data.list.gradeIdArr2;
            this.order.courseCategoryIds = res.data.data.list.categoryIdArr2;
            this.order.address = res.data.data.list.address;
            this.order.regionName = Number(res.data.data.list.regionName);
            this.order.teacherIdOnline = res.data.data.list.teacherIdOnline;
            this.order.teacherIdOffline = res.data.data.list.teacherIdOffline;
            // 线上诊断
            if (res.data.data.list.teacherIdOnline == null && res.data.data.list.teacherIdOnlineArr == null) {
              this.order.teacherIdOnlineArr = []
            } else {
              if (res.data.data.list.teacherIdOnlineArr == []) {
                this.order.teacherIdOnlineArr = []
              } else {
                if (res.data.data.list.teacherIdOnlineArr) {
                  this.order.teacherIdOnlineArr = JSON.parse(res.data.data.list.teacherIdOnlineArr)
                } else {
                  this.order.teacherIdOnlineArr = [res.data.data.list.teacherIdOnline]
                }
              }
            }
            // 线下诊断
            if (res.data.data.list.teacherIdOffline == null && res.data.data.list.teacherIdOfflineArr == null) {
                this.order.teacherIdOfflineArr = []
            } else {
              if (res.data.data.list.teacherIdOfflineArr == []) {
                  this.order.teacherIdOfflineArr = []
              } else {
                if (res.data.data.list.teacherIdOfflineArr) {
                    this.order.teacherIdOfflineArr = JSON.parse(res.data.data.list.teacherIdOfflineArr)
                } else {
                    this.order.teacherIdOfflineArr = [res.data.data.list.teacherIdOffline]
                }
              }
            }

            this.order.teacherIdOnline = null;
            this.order.teacherIdOffline = null;
            this.order.startTime = JSON.parse(res.data.data.list.onlineTime);
            this.order.orderStatus = res.data.data.list.orderStatus
            this.order.isDiagnosisAllPay = res.data.data.list.customerIspay + "";
            this.order.diagnosisTime = res.data.data.list.customerPaytime;
            // this.order.startTimeDay = this.order.startTime[0];
            // this.order.startTimeHour = this.order.startTime[1];

            this.order.diagnosisAllPayMoney =
              res.data.data.list.customerPaymoney;
            if (res.data.data.list.onlineTime !== null) {
              this.order.onTime = JSON.parse(res.data.data.list.onlineTime)[0];
              this.order.startTimeHour = JSON.parse(
                res.data.data.list.onlineTime
              )[1];
              this.order.onEndTime = JSON.parse(
                res.data.data.list.onlineTime
              )[2];
            }
            if (res.data.data.list.offlineTime !== null) {
              this.order.offTime = JSON.parse(
                res.data.data.list.offlineTime
              )[0];
              this.order.OffTimeHour = JSON.parse(
                res.data.data.list.offlineTime
              )[1];
              this.order.offEndTime = JSON.parse(
                res.data.data.list.offlineTime
              )[2];
            }

            this.order.onlineStatus = res.data.data.list.onlineStatus;
            this.order.offlineStatus = res.data.data.list.offlineStatus;
            // this.order.offlineTime = this.order.startTime[1];

            this.order.payAlltype = res.data.data.list.payAlltype;
            // this.order.isAllPay = res.data.data.list.customerIsallpay + "";
            this.order.isAllPay = res.data.data.list.customerIsallpay

            this.order.allPayMoney = res.data.data.list.customerAllpaymoney;
            this.order.payTime = res.data.data.list.customerAllpaytime;

            if (this.order.onlineStatus == "1") {
              this.checked = true;
            } else {
              this.checked = false;
            }
            if (this.order.offlineStatus == "1") {
              this.checked1 = true;
            } else {
              this.checked1 = false;
            }
            if (res.data.data.list.stages !== null) {
              this.order.stages = JSON.parse(res.data.data.list.stages);
            }
          } else {
             this.$message({ message: res.data.message,  type: "error"  });
          }
        });
      // if (this.order.isAllPay == "1") {
      //       this.order.stages = [
      //         {
      //           stagesMoney: "", // 分期金额
      //           stagesDate: "", // 分期时间
      //           payType: "" // 付款渠道
      //         }
      //       ];
      //     }
      //     if (this.order.isAllPay == "2") {
      //       this.order.allPayMoney = "";
      //       this.order.payTime = "";
      //       // this.order.payType = "";
      //     }
      //     if (this.order.isAllPay == "3") {
      //       this.order.stages = [
      //         {
      //           stagesMoney: "", // 分期金额
      //           stagesDate: "", // 分期时间
      //           payType: "" // 付款渠道
      //         }
      //       ];
      //       this.order.allPayMoney = "";
      //       this.order.payTime = "";
      //       // this.order.payType = "";
      //     }
    },

    isFull () {
      this.order.stages = [
        {
          stagesMoney: "", // 分期金额
          stagesDate: "", // 分期时间
          payType: "", // 付款渠道
          agingClassHour: "",
          agingFamilyHour: ""
        }
      ];
    },
    isNo () {
      this.order.allPayMoney = "";
      this.order.payTime = "";
      this.order.payAlltype = "";
    },
    //添加输入框
    addInput () {
      this.order.stages.push({
        stagesMoney: "",
        stagesDate: "",
        payType: "", // 付款渠道
        agingClassHour: "",
        agingFamilyHour: ""
      });
    },
    //减少输入框
    removeItem () {
      if (this.order.stages.length > 1) {
        this.order.stages.pop();
      } else {
        this.order.stages.splice(0, this.order.stages.length);
      }
    },
    //添加输入框
    addInput1 () {
      this.order.renews.push({
        renewMoney: "",
        renewTime: "",
        renewType: "", // 付款渠道
        classHourRenew: "",
        familyHourRenew: ""

      });
    },
    //减少输入框
    removeItem1 () {
      if (this.order.renews.length > 1) {
        this.order.renews.pop();
      } else {
        this.order.renews.splice(0, this.order.renews.length);
      }
    },
    orderShow (customer) {
      this.showEdit = true;
      this.customer = customer;
      this.order.studentName = customer.customerStudent;
      this.order.type = customer.type;
      this.order.customerInformationId = customer.customerId;
      this.customerId = customer.customerId;
    },
    closeEditDialog () {


      if (this.customerId === 0) {
        this.showEdit = false;
      } else {
        this.showEdit = false;
        this.$emit("resetSuccesType", this.customer);
      }


      this.order.isDiagnosisAllPay = "";
      this.order.diagnosisAllPayMoney = "";
      this.order.diagnosisTime = "";
      this.order.diagnosisPayType = "";
      this.order.isAllPay = "";
      this.order.allPayMoney = "";
      this.order.payTime = "";
      this.order.payType = "";
      this.order.state = "";

      this.order.classHour = ""
      this.order.familyHour = ""
      this.order.renews = [{ renewMoney: "", renewTime: "",  renewType: "" , classHourRenew: "", familyHourRenew: "" }]
      this.order.stages = [{ stagesMoney: "",  stagesDate: "",  payType: "", agingClassHour: "", agingFamilyHour: "" }]

      this.$refs.order.resetFields();

      this.order.startTimeHour = ""
      this.order.onEndTime = ""
      this.order.OffTimeHour = ""
      this.order.offEndTime = ""


    },
    getGrade () {
      axios
        .get(`${apiBaseUrl}/grade/getGrade`,{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        })
        .then(res => {
          if (res.data.data.length > 0) {
            this.order.gradeList = res.data.data;
          } else {
            this.$message({
              message: "获取年级列表失败",
              type: "error"
            });
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    getTeachers () {
      axios
        .get(`${apiBaseUrl}/schedule/teacherDiagnosisList`,{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        })
        .then(res => {
          this.teachers = res.data.data;
        })
        .catch(error => {
          this.$message({
            message: "获取老师列表失败",
            type: "error"
          });
        });
    },
    //获取课程类别
    getCategoryList () {
      axios
        .get(`${apiBaseUrl}/category/list`,{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        })
        .then(res => {
          this.categoryList = res.data.data;
        })
        .catch(error => {
          this.$message({
            message: "获取课程列表失败",
            type: "error"
          });
        });
    },

    saveEditForm () {

          if (this.checked == true) {
              this.order.onlineStatus = "1";
          } else {
              this.order.onlineStatus = "2";
          }

          if (this.checked1 == true) {
              this.order.offlineStatus = "1";
          } else {
              this.order.offlineStatus = "2";
          }

      // this.$refs["order"].validate(valid => {
      //   if (valid) {
          this.order.onlineTime = [ this.order.onTime,  this.order.startTimeHour,  this.order.onEndTime  ];

          if (this.order.onlineTime.length == 0) {
              this.order.onlineTime = "";
          }

          this.order.offlineTime = [ this.order.offTime,  this.order.OffTimeHour,  this.order.offEndTime  ];

          if (this.order.offlineTime.length == 0) {
              this.order.offlineTime = "";
          }

          // if (this.order.isRenew == 2) {
          //     this.order.renews = null
          // }



          this.order.classHour = this.order.classHour ? Number(this.order.classHour) : 0
          this.order.familyHour = this.order.familyHour ? Number(this.order.familyHour) : 0


          if(this.order.stages.length > 1){
             this.order.stages.forEach((itme)=>{
               itme.agingClassHour = itme.agingClassHour ? Number(itme.agingClassHour) : 0
               itme.agingFamilyHour = itme.agingFamilyHour ? Number(itme.agingFamilyHour) : 0
             })
          }else{
            //  this.order.stages = []
          }

          if(this.order.renews.length > 1){
             this.order.renews.forEach((itme)=>{
               itme.familyHourRenew = itme.familyHourRenew ? Number(itme.familyHourRenew) : 0
               itme.classHourRenew = itme.classHourRenew ? Number(itme.classHourRenew) : 0
             })
          }else{
            //  this.order.renews = []
          }

          this.order.customerIsallpay = this.order.isAllPay

          // this.order.renews = JSON.stringify(this.order.renews)
          // this.order.stages = JSON.stringify(this.order.stages)

          this.order.auditId = this.ApprovalPeople
          this.order.commitRemark = this.chengRemarks

          axios.post(`${apiBaseUrl}/orderCustomer/update`, this.order,{ headers :{'authorization': sessionStorage.getItem('tokenInfo')}}).then(res => {
              if (res.data.code === 200) {
                this.$message({  message: "编辑成功",  type: "success" });
                this.$emit("refreshOrder");
                this.showEdit = false;

                this.ApprovalPeople = "";
                this.chengRemarks = "";
                this.order.auditId = "";
                this.order.commitRemark = "";

                this.order.isDiagnosisAllPay = "";
                this.order.diagnosisAllPayMoney = "";
                this.order.diagnosisTime = "";
                this.order.diagnosisPayType = "";
                this.order.isAllPay = "";
                this.order.allPayMoney = "";
                this.order.payTime = "";
                this.order.payType = "";

                this.order.startTimeHour = ""
                this.order.onEndTime = ""
                this.order.OffTimeHour = ""
                this.order.offEndTime = ""

                this.order.classHour = ""
                this.order.familyHour = ""

                this.order.renews = [{  renewMoney: "",  renewTime: "",   renewType: ""  , classHourRenew: "", familyHourRenew: "" }]

                this.order.stages = [ { stagesMoney: "",  stagesDate: "",   payType: "" , agingClassHour: "", agingFamilyHour: "" }]

                this.$refs.order.resetFields();
                // this.order.startTime.splice(0, this.order.startTime.length);
              } else {
                  this.order.classHour = this.order.classHour ? Number(this.order.classHour) : ""
                  this.order.familyHour = this.order.familyHour ? Number(this.order.familyHour) : ""

                  if(this.order.stages.length > 1){
                    this.order.stages.forEach((itme)=>{
                      itme.agingClassHour = itme.agingClassHour ? Number(itme.agingClassHour) : ""
                      itme.agingFamilyHour = itme.agingFamilyHour ? Number(itme.agingFamilyHour) : ""
                    })
                  }

                  if(this.order.renews.length > 1){
                    this.order.renews.forEach((itme)=>{
                      itme.familyHourRenew = itme.familyHourRenew ? Number(itme.familyHourRenew) : ""
                      itme.classHourRenew = itme.classHourRenew ? Number(itme.classHourRenew) : ""
                    })
                  }
                this.$message({ message: res.data.message, type: "error"  });
              }
            });
      //   }
      // });
      this.$emit("refresh");
    }
  },
  beforeCreate () { },

  created () {
    this.getGrade();
    this.getTeachers();
    this.getCategoryList();
  },

  beforeMount () { },

  mounted () {
    this.payTypes = JSON.parse(sessionStorage.getItem('payTypesList'))

    axios.get(`${ apiBaseUrl }/dict/getDictionary/${'地域'} `,{ headers: { 'authorization': sessionStorage.getItem('tokenInfo') }}).then((res)=>{
      this.optionsListt = res.data.data
    })

    axios.get(`${apiBaseUrl}/orderCustomerAudit/findAuditList`,{ headers:{'authorization': sessionStorage.getItem('tokenInfo')}}).then(res => {
      this.optionList2 = res.data.data
    })
  },

  beforeUpdate () { },

  updated () { },

  beforeDestroy () { },
  destroyed () { },

  activated () { }
};
</script>

<style scoped>
.el-icon-timer {
  position: relative;
  top: 8px;
  font-size: 35px;
}

/* 兼容移动端 */
@media screen and (max-width: 750px) {

  /* 兼容移动端 */
  .el-dialog {
    width: 83%;
  }
}
</style>



// WEBPACK FOOTER //
// src/manager/components/OrderUpdate.vue